import { useQuery } from '@tanstack/react-query';
import { TenantsApi } from '@/api/tenants';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Indique si le tenant de l'utilisateur courant est un tenant de démonstration
 * (tenants.is_demo). Sert à n'activer certaines aides (ex: tour guidé) que sur
 * les démos, sans jamais impacter les tenants en production.
 */
export function useDemoTenant(): boolean {
  const { user } = useAuth();

  const { data } = useQuery({
    queryKey: ['demo_tenant', user?.id],
    enabled: !!user,
    staleTime: Infinity,
    queryFn: async () => {
      const res = await TenantsApi.getMyTenant();
      return res.ok ? Boolean(res.value.is_demo) : false;
    },
  });

  return Boolean(data);
}
